/**
 * @desc 树状列表
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.AppDomainMenuTreeResponseDto>;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/menu/tree/${code}`, {
      method: "GET",

      ...options,
    }),
  );
}
